import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '../assets/fontawesome.all.min';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export const PRIMARY_COLOR = '#a4000e';

export default new Vuetify({
    theme: {
        options: {customProperties: true},
        themes: {
            light: {
                // primary: '#ed1f29',
                primary: '#a4000e',
                secondary: '#dfdfdf',
                accent: '#998065',
                error: '#ff5252',
            },
        },
    },
});
